import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowsRotate = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18.21 13.003a.75.75 0 0 0-.929.51 5.52 5.52 0 0 1-5.308 3.987c-2.079 0-3.962-1.196-4.89-3h3.137a.75.75 0 0 0 .75-.75c0-.414-.306-.75-.722-.75h-5a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0v-3.19C7.242 17.636 9.505 19 11.973 19a7.04 7.04 0 0 0 6.722-5.04c.144-.426-.087-.813-.484-.957m.541-8.503a.75.75 0 0 0-.75.75v3.19c-1.24-2.08-3.506-3.44-6-3.44-3.093 0-5.858 2.072-6.721 5.04a.75.75 0 0 0 .51.929.747.747 0 0 0 .93-.51A5.53 5.53 0 0 1 12.001 6.5c2.079 0 3.962 1.196 4.89 3h-3.14a.75.75 0 0 0-.75.75c0 .412.337.75.75.75h5a.75.75 0 0 0 .75-.75v-5a.75.75 0 0 0-.75-.75"
    }));
export default SvgArrowsRotate;
